import { OrganizationService } from 'src/app/features/organization/organization.service'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { BreadCrumbActions } from 'src/app/shared/components/breadcrumb/breadcrumb.actions'
import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { Store } from '@ngrx/store'
import { BsModalService } from 'ngx-bootstrap/modal'
import { Observable } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import { BulkAction } from 'src/app/shared/interfaces'
import { roleActions } from '../../role/role.actions'
import { Organization } from '../organization'
import { organizationActions } from '../organization.actions'
import { organizationSelectors } from '../organization.selectors'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { dmsTableSelectors } from 'src/app/shared/components/dms-table/dms-table.selectors'
import { take } from 'rxjs/operators'
import { TableType } from 'src/app/shared/constants'
import { environment } from 'src/environments/environment'
import { GenericMainWrapperModalComponent } from 'src/app/shared/components/generic-main-wrapper-modal/generic-main-wrapper-modal.component'
import { getNavItems } from 'src/app/shared/components/generic-main-wrapper-modal/generic-main-wrapper-modal-utils'
import { NavItemType } from 'src/app/shared/components/generic-main-wrapper-modal/generic-main-wrapper-modal-constants'
@UntilDestroy()
@Component({
  selector: 'organizations-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class OrganizationIndexComponent implements OnInit {
  public isLoading$: Observable<boolean>
  public organizations$: Observable<Organization[]>
  public accessRights = AccessRights
  public actualTab: number = 0
  public defaultTab: number = 0
  public form: UntypedFormGroup
  private URL_BASE = '/organizations'
  public organizationModuleConfig = environment.moduleConfigs.organizationModule
  constructor(
    private modalService: BsModalService,
    private store: Store<AppState>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private organizationService: OrganizationService
  ) {}

  ngOnInit() {
    const navigationEntries = performance.getEntriesByType(
      'navigation'
    ) as PerformanceNavigationTiming[]
    if (
      navigationEntries.length > 0 &&
      navigationEntries[0].type === 'back_forward' &&
      navigationEntries[0].name.includes('(modal:') &&
      this.activatedRoute.outlet == 'primary'
    ) {
      this.router.navigate(
        [
          {
            outlets: {
              modal: null
            }
          }
        ],
        { replaceUrl: true }
      )
    }
    if (
      navigationEntries.length > 0 &&
      navigationEntries[0].type === 'reload'
    ) {
      //hard Refresh
      this.router.navigate(
        [
          {
            outlets: {
              modal: null
            }
          }
        ],
        { replaceUrl: true }
      )
    }
    this.isLoading$ = this.store.select(organizationSelectors.selectIsLoading)
    this.form = this.fb.group({
      isActive: [true, []],
      selectedType: ['all', []]
    })
    this.form.valueChanges.pipe(untilDestroyed(this)).subscribe((form) => {
      if (this.form.controls.isActive.value === true) {
        this.actualTab = 0
      } else {
        this.actualTab = 1
      }
    })
    this.store
      .select(dmsTableSelectors.selectFeature(TableType.ORGANIZATIONS))
      .pipe(take(1))
      .subscribe((item) => {
        if (item) {
          this.actualTab = item.activeTab
          this.defaultTab = item.activeTab
          if (this.actualTab == 0) this.form.controls['isActive'].setValue(true)
          else this.form.controls['isActive'].setValue(false)
        } else {
          this.form.controls['isActive'].setValue(true)
        }
      })
    this.store.dispatch(roleActions.fetchMany({}))

    this.organizations$ = this.store.select(organizationSelectors.selectAll)
  }
  public onClickSelectedType(type: string) {
    this.form.controls.selectedType.patchValue(type)
  }

  public onClickRow(organization: Organization) {
    this.store.dispatch(
      organizationActions.fetchOneById({
        id: organization.id,
        params: RequestQueryBuilder.create({
          join: [
            { field: 'tags' },
            { field: 'addresses' },
            { field: 'documents' },
            { field: 'primaryAddress' },
            { field: 'invoiceAddress' },
            { field: 'roles' },
            { field: 'userRoles' },
            { field: 'userRoles.organization' },
            { field: 'userRoles.member' },
            { field: 'userRoles.member.role' },
            { field: 'userRoles.member.subscribers' },
            { field: 'requiredSubscriptions' }
          ]
        })
      })
    )
    this.router.navigate(['/organizations', organization.id])
    this.organizationService.showModal = true
    const modalRef = this.modalService.show(GenericMainWrapperModalComponent, {
      initialState: {
        navItems: getNavItems(
          String(organization.id),
          {
            fullAccess: this.organizationModuleConfig.isActive,
            isActive: this.organizationModuleConfig.isActive
          },
          NavItemType.ORGANIZATION
        ),
        actions: organizationActions,
        entity: organization,
        joins: [
          { field: 'tags' },
          { field: 'addresses' },
          { field: 'documents' },
          { field: 'primaryAddress' },
          { field: 'invoiceAddress' },
          { field: 'roles' },
          { field: 'userRoles' },
          { field: 'userRoles.organization' },
          { field: 'userRoles.member' },
          { field: 'userRoles.member.role' },
          { field: 'userRoles.member.subscribers' },
          { field: 'requiredSubscriptions' }
        ],
        selectIdRouteParam$: this.store.select(
          organizationSelectors.selectIdRouteParam
        ),
        moduleConfigIsActive: this.organizationModuleConfig.isActive,
        entities$: this.store.select(organizationSelectors.selectEntities),
        modalRoute: 'modal-org',
        service: this.organizationService,
        type: NavItemType.ORGANIZATION,
        ariaLabelKey: 'wcag.organizationMenu'
      },
      class: 'modal-lg modal-dialog-scrollable modal-dialog-centered'
    })
    modalRef.onHide.pipe(take(1)).subscribe((modal) => {
      this.organizationService.showModal = false
    })
  }

  public onClickCreate() {
    this.router.navigate(['/organizations/create'])
  }

  public onBulkAction(bulkAction: BulkAction) {
    if (bulkAction == BulkAction.DELETE) {
      console.log('deleteMany')
    }
  }
  public onTabSelected(tab: number): void {
    this.actualTab = tab
    if (tab === 1) {
      this.form.controls.isActive.setValue(false)
    } else {
      this.form.controls.selectedType.setValue(true)
    }
  }
}
